import Modal from "react-modal";
import React, { useCallback, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Line } from "react-chartjs-2";
import AfterLoginNav from "./AfterLoginNav";
import { toast } from "react-toastify";
import { getGoldPriceHistory } from "../services/gold-price";
import { getCommoditiesList } from "../services/commodities";
import { toPersianNum } from "../utils/persianNumbers";

export default function ChartModal({
  modalIsOpen,
  Openchanger,
  activeChart = "buy",
}) {
  Modal.setAppElement("#root");
  const [chartColor, setChartColor] = useState(null);
  const [commodities, setCommodities] = useState([]);
  const [selectedChart, setSelectedChart] = useState("1");
  const [labels, setLabels] = useState([]);
  const [buyValues, setBuyValues] = useState([]);
  const [sellValues, setSellValues] = useState([]);
  const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
  const customStylesDesktop = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "80vw",
      height: "60vh",
      overflowY: "auto",
      border: "0px",
      overflowY: "hidden",
      position: "relative",
      borderRadius: "0.8rem",
      inset: "9px",
    },
  };

  const customStylesMobile = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "80vw",
      height: "50vh",
      overflowY: "auto",
      border: "0px",
      position: "relative",
      borderRadius: "0.4rem",
      inset: "0px",
      margin: "0vh 0px 0px 0px",
    },
  };

  const getHistory = useCallback(() => {
    getGoldPriceHistory(selectedChart)
      .then((res) => {
        if (res.status == 200) {
          if (res && res.data && res.data.results) {
            try {
              const tmpLabels = (res?.data?.results || []).map(
                (item) => (item?.created_at || "").split("T")[0]
              );
              const bValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              const sValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              setBuyValues(bValues);
              setSellValues(sValues);
              setLabels(tmpLabels);
            } catch (e) {}
          }
        } else {
          toast.error(res?.data?.detail);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.detail);
      });
  }, [selectedChart]);
  function afterOpenModal() {}
  function closeModal() {
    Openchanger(false);
  }
  useEffect(() => {
    getCommoditiesList().then((data) => {
      setCommodities(data.data.results);
    });
  }, []);
  useEffect(() => {
    getHistory();
  }, [selectedChart]);
  useEffect(() => {
    const selectedCommodityChart = commodities.find(
      (el) => el.id == selectedChart
    );
    if (selectedCommodityChart) {
      setChartColor(selectedCommodityChart?.ui_data?.colors?.primary);
    }
  }, [commodities, selectedChart]);
  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={isSmall ? customStylesMobile : customStylesDesktop}
        contentLabel="Example Modal"
        backdrop="static"
        id={"factor-modal"}
      >
        <div className="header-modal-wrapper">
          <AfterLoginNav title={"تاریخچه قیمت ها"} hasBack={closeModal} />
        </div>
        <div className={"container"} id={"factor-mbody"}>
          <div className="remove-cross" onClick={() => Openchanger(false)}>
            &#10006;
          </div>
          <div className="select-box-items minimal-select select-chart-mobile">
            {commodities.map((data) => (
              <div
                onClick={() => setSelectedChart(data.id)}
                className={
                  selectedChart == data.id
                    ? "el-select-box"
                    : "el-select-box active-select-box"
                }
              >
                {data.name}
              </div>
            ))}
          </div>
          {chartColor && buyValues && sellValues && (
            <Line
              height={300}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
              }}
              data={{
                labels: labels,
                datasets: [
                  {
                    label: `تاریخچه قیمت ${toPersianNum(
                      (commodities || []).find((el) => el.id == selectedChart)
                        ?.name
                    )}`,
                    data: activeChart === "buy" ? buyValues : sellValues,
                    borderWidth: 1,
                    borderColor: chartColor,
                    fill: true,
                    pointBackgroundColor: chartColor,
                    backgroundColor: chartColor,
                    tension: 0.7,
                  },
                ],
              }}
            />
          )}
        </div>
      </Modal>
    </>
  );
}
